import {Component, OnInit} from '@angular/core';
import {checkboxLabels, TournamentTunerMethodsService} from "../../../../services/tournament-tuner-methods.service";

@Component({
  selector: 'app-tournament-tuner-type-checkboxes',
  templateUrl: './tournament-tuner-type-checkboxes.component.html',
  styleUrls: ['./tournament-tuner-type-checkboxes.component.scss']
})
export class TournamentTunerTypeCheckboxesComponent implements OnInit {

  constructor(
    private tournamentTunerService: TournamentTunerMethodsService,
  ) { }

  ngOnInit(): void {
  }

  getTournamentCheckBoxLabels(): checkboxLabels {
    return this.tournamentTunerService.checkBoxLabels;
  }

  getObjectKeys(inputObject: Object): string[] {
    return Object.keys(inputObject);
  }

  setChosenTournamentType($event) {
    this.tournamentTunerService.chosenTournamentType = $event.target.id;
  }

  getChosenTournamentType(): string {
    return this.tournamentTunerService.chosenTournamentType;
  }

  getThirdPlaceTournamentAvailable(): boolean {
    return this.tournamentTunerService.thirdPlaceTournamentAvailable;
  }

  setThirdPlaceTournamentAvailable() {
    this.tournamentTunerService.thirdPlaceTournamentAvailable = !this.getThirdPlaceTournamentAvailable();
  }

  isConventional(): boolean {
    return this.tournamentTunerService.isConventional();
  }

}
